var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.18 51.185H51.6501C53.3263 51.185 54.3706 49.3722 53.5352 47.9182L31.6507 10.0159C30.8152 8.56729 28.7213 8.56729 27.8805 10.0159L5.99864 47.9182C5.16321 49.3722 6.21018 51.185 7.88639 51.185H22.3565",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7675 40.6028C28.3537 40.6028 27.1595 39.5505 26.9774 38.1474L25.4458 26.1782C25.2075 24.3226 26.1821 22.5206 27.8664 21.7065C29.066 21.1255 30.4664 21.1255 31.666 21.7065C33.3502 22.5232 34.3249 24.3226 34.0866 26.1782L32.555 38.1474C32.3756 39.5505 31.1813 40.6028 29.7648 40.6028H29.7675Z",
    stroke: "#DA291C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7679 51.3189C31.6401 51.3189 33.1578 49.8012 33.1578 47.929C33.1578 46.0568 31.6401 44.5391 29.7679 44.5391C27.8957 44.5391 26.3779 46.0568 26.3779 47.929C26.3779 49.8012 27.8957 51.3189 29.7679 51.3189Z",
    stroke: "#DA291C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAlert);
export default __webpack_public_path__ + "static/media/SecurityAlert.57e609c56b6bd4880ee5b1707f5bfcb6.svg";
export { ForwardRef as ReactComponent };